const ABOUT_PARAGRAPHS = [
    {
        id: "id",
        text: "Je suis Simon Marie, consultant en protection des données personnelles et conformité réglementaire.",
    },
    {
        id: "role",
        text: "J'interviens auprès de dirigeants, indépendants et structures patrimoniales pour repérer les informations visibles, les pratiques numériques à corriger et les obligations courantes à sécuriser.",
    },
    {
        id: "limite",
        text: "Mon intervention ne remplace pas celle d'un avocat, d'un commissaire aux comptes ou d'un DPO désigné lorsque la situation l'exige. Elle se situe en amont, pour clarifier une situation, réduire les expositions inutiles et préparer les corrections nécessaires.",
    },
];

export function About() {
    return (
        <section
            id="qui-suis-je"
            className="border-b border-slate-200 bg-white"
            data-testid="about-section"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16 py-14 md:py-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
                    <div className="lg:col-span-4">
                        <p className="reveal text-xs tracking-[0.18em] uppercase text-slate-500 mb-4">
                            Repère
                        </p>
                        <h2
                            className="reveal font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0B132B] font-medium leading-[1.05]"
                            data-testid="about-title"
                        >
                            Qui suis-je
                        </h2>
                    </div>

                    <div className="lg:col-span-7 lg:col-start-6">
                        <div
                            className="space-y-5 text-base lg:text-lg text-slate-700 leading-relaxed"
                            data-testid="about-body"
                        >
                            {ABOUT_PARAGRAPHS.map((p) => (
                                <p key={p.id} className="reveal">
                                    {p.text}
                                </p>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
